import { useDashboardStats } from "../../../app/hooks/useDashboardStats.js";
import { TrendingPillList } from "../../dashboard/Trending.js";
import { MobileCard } from "./mobileCard.js";

/**
 * TRENDING (ART-176) — the spike feed, missing from the mobile home until now and placed FIRST in the stacks
 * that carry it (owner + content, releases:read at the nav document). It reuses the desktop {@link
 * TrendingPillList} so the two surfaces read one list and can never disagree about what is trending.
 *
 * It renders NOTHING when nothing is trending (the `showtime` pattern), rather than a permanent empty lead
 * card: "trending first" means first WHEN there is something to say, and an empty card at the top of every
 * home would be daily noise. `TrendingDetection`'s gates already keep this list honest (it is a real spike,
 * not a mover grid), so an item here has earned the lead.
 */
export function TrendingHomeCard() {
  const q = useDashboardStats();
  const items = q.data?.trending?.items ?? [];
  if (items.length === 0) return null;
  return (
    <MobileCard title="Trending">
      <TrendingPillList items={items} />
    </MobileCard>
  );
}
